import React from 'react'
import PageComponent from './PageComponent'
import './FormRow.scss'
import ReactMarkdown from 'react-markdown'
import ContactForm from '../Forms/ContactForm'
import PresentationForm from '../Forms/PresentationForm/PresentationForm'
import PresentationFormStrapiWrapper from './Wrappers/PresentationFormStrapiWrapper'

const PresentationFormWithNewsletter = () => {
    return (
        <PresentationFormStrapiWrapper>
            <PresentationForm showNewsletter={true} />
        </PresentationFormStrapiWrapper>
    )
}
const PresentationFormWithoutNewsletter = () => {
    return (
        <PresentationFormStrapiWrapper>
            <PresentationForm showNewsletter={false} />
        </PresentationFormStrapiWrapper>
    )
}

const formsMap = {
    presentation: PresentationFormWithNewsletter,
    'presentation without newsletter': PresentationFormWithoutNewsletter,
    contact: ContactForm,
}

const FormRow = ({content, formName}) => {
    const Component = formsMap[formName]

    return (
        <PageComponent backgroundColor={'lightgray'}>
            <div className="form-row__wrapper">
                <div className="form-row__content container">
                    <ReactMarkdown source={content} />
                </div>
                <div className="form-row__form">{Component && <Component />}</div>
            </div>
        </PageComponent>
    )
}

export default FormRow
